import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'

type UseElectronicsLpVersionReturnType = 'buy' | 'sell'

const useElectronicsLpVersion = (): UseElectronicsLpVersionReturnType => {
  const { relativeUrl } = useBrowserNavigation()

  return relativeUrl.includes('buy') ? 'buy' : 'sell'
}

export default useElectronicsLpVersion
